function easeInOutQuad(t: number, b: number, c: number, d: number) {
  let n = t;
  n /= d / 2;
  if (n < 1) {
    return (c / 2) * n * n + b;
  }
  n -= 1;
  return (-c / 2) * (n * (n - 2) - 1) + b;
}

function scrollToPosition(
  position: number,
  duration: number,
  callback: (() => void) | null = null
) {
  const start = window.scrollY || window.pageYOffset;
  const to = position;
  const change = to - start;
  const increment = 20;
  let currentTime = 0;

  const animateScroll = () => {
    currentTime += increment;
    const val = easeInOutQuad(currentTime, start, change, duration);

    window.scrollTo(0, val);

    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    } else if (callback) {
      callback();
    }
  };

  if (duration > 0) {
    animateScroll();
  } else {
    window.scrollTo(0, to);
    if (callback) {
      callback();
    }
  }
}

function scrollTo(
  anchor: HTMLElement,
  duration = 400,
  callback = () => {},
  offset = 0
) {
  const to = Math.max(anchor.offsetTop - offset, 0);

  scrollToPosition(to, duration, callback);
}

export function scrollBodyTo(
  anchor: HTMLElement,
  duration: number,
  callback = () => {},
  offset = 0
) {
  scrollTo(anchor, duration, callback, offset);
}

export function scrollToTop(duration = 400) {
  scrollToPosition(0, duration);
}
